import {createRoot} from 'react-dom/client'
import {useState, useEffect} from 'react'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import './app/styles/mobile-touch.css'
import './app/styles/touch-feedback.css'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
// PWA Service Worker
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import UpdateNotification from './app/components/UpdateNotification'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()

// App wrapper to handle service worker updates
const App = () => {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorkerRegistration | undefined>();

  useEffect(() => {
    serviceWorkerRegistration.register({
      onSuccess: () => {
        // TrackVAS PWA is ready for offline use
      },
      onUpdate: (registration) => {
        // New version available
        setWaitingWorker(registration)
      },
    })
  }, []);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <MetronicI18nProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </MetronicI18nProvider>
      </QueryClientProvider>
      <UpdateNotification registration={waitingWorker} />
    </>
  );
};

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(<App />)
}
